import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {ThingActivatorsInterface} from '@app/app/shared/interfaces/thing/thing-activator.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './park-activator-logic-controls.html',
  selector: 'park-activator-logic-controls'
})

export class ParkActivatorLogicControlsComponent implements OnDestroy {
  @Input() public activators: ThingActivatorsInterface[];
  @Input() public parkId: string;
  @Input() public id: string;
  @Input() public color: string;

  objectKeys = Object.keys;

  private timerSub: Subscription;

  public isRunningAuto = false;

  private MODE_AUTO = 'auto';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  public isAllAuto() {
    let isAuto = true;

    Object.keys(this.activators).forEach((activatorId) => {
      if (this.activators[activatorId].md !== this.MODE_AUTO) {
        isAuto = false;
      }
    });

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/activators-logic/park-activator-logic-controls.component.ts